angular.module( 'acme.view.application.coupons.create.schedule', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.coupons.create.schedule.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var couponsCreateSchedule = {
        name: 'application.coupons.create.schedule',
        url: '/schedule',
        views: {
          "subview-main": {
            controller: 'CouponsCreateScheduleController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/coupons/create/schedule/schedule.tpl.html'
          }
        },
        data: {
          pageTitle: 'Coupon Details',
          /** Secure With Roles **/
          permissions: ['COUPONS_VIEW']
        }
      };

    $stateProvider
      .state(couponsCreateSchedule);
});
